import Request from "../Request.js";

const projectFileCategories = {
  checkBulkDownload(categoryId) {
    return Request.post(`/api/v1/project-file-category/zipfile/${categoryId}/`);
  },
  getZipFileUrl(projectFileCategoryID) {
    return Request.get(
      `/project-file-category/download/${projectFileCategoryID}/`
    );
  },
  getProjectFileCategories(projectId) {
    return Request.get(
      `/file-category/api/v1/file-category/?projectId=${projectId}`
    );
  },
  listProjectFiles(
    fileCategoryID,
    pageNumber,
    pageSize = 1,
    isUsedByRC = true
  ) {
    const rcParam = isUsedByRC ? "&is_used_by_rc=true" : "";
    const modeParam = pageNumber === 1 ? "" : "&mode=base";
    const dateTakenParam = isUsedByRC
      ? "&ordering=date_taken"
      : "&ordering=file_name";

    return Request.get(
      `/project-file/api/v1/projects-files/?fileCategoryId=${fileCategoryID}&page=${pageNumber}&pageSize=${pageSize}${dateTakenParam}${rcParam}${modeParam}`
    );
  },
  shareProjectFile(data, fileCategoryID) {
    return Request.post(
      `/project-file/api/v1/projects-files/${fileCategoryID}/share/`,
      data
    );
  },
  getProjectFileShareLink(id) {
    return Request.post(
      `/project-file/api/v1/projects-files/${id}/generate-shared-file-link/`
    );
  },
  getProjectImage(id) {
    return Request.get(`/project-file/api/v1/projects-files/${id}/`);
  },
};
export default projectFileCategories;
